<template>
  <div class="flex flex-col space-y-5 pl-4 py-2">
    <a
      v-for="(item, index) in items"
      :key="index"
      :href="item.href || '#'"
      class="flex items-center space-x-2 text-gray-600 hover:text-primary transition-colors text-sm"
      @click="(e) => handleItemClick(item, e)"
    >
      <component :is="item.icon" />
      <PContent class="font-semibold hover:font-bold">{{ item.label }}</PContent>
    </a>
  </div>
</template>

<script setup lang="ts">
import PContent from '@/components/atoms/text/PContent.vue'
import type { SubmenuItem } from '../types/navigation'

interface Props {
  items: SubmenuItem[]
}

const props = defineProps<Props>()

const handleItemClick = (item: SubmenuItem, event: MouseEvent) => {
  event.preventDefault()
  if (item.href) {
    window.location.href = item.href
  }
}
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

